function sortByKey(key) {
  return function (a, b) {
    const aValue = a[key].toUpperCase()
    const bValue = b[key].toUpperCase()

    if (aValue < bValue) return -1
    if (aValue > bValue) return 1
    return 0
  }
}

function sortByDateKey(key) {
  return function (a, b) {
    if (!a[key] && !b[key]) return 0
    if (!a[key]) return 1
    if (!b[key]) return -1

    if (a[key] < b[key]) return 1
    if (a[key] > b[key]) return -1
    return 0
  }
}

function sortByFileSize(a, b) {
  return a.size - b.size
}

export { sortByKey, sortByDateKey, sortByFileSize }
